import { getStorageValue } from 'src/hooks/useLocalStorage';
import http from './http';

class BenefitsMasterService {
  static uploadBenefitsMaster(data: any) {
    return http.patch('/benefits-master/upload', data);
  }

  static uploadBenefitsMasterByModal(data: any) {
    return http.patch('/benefits-master', data);
  }

  static downloadBenefitsMaster(): string {
    return `${process.env.REACT_APP_API_URL}benefits-master?token=${getStorageValue('accessToken', null)}`;
  }
}
export default BenefitsMasterService;
